module.exports = __webpack_public_path__ + "static/media/nf.1ac92a89.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nf.svg
// module id = 2173
// module chunks = 0